import * as React from "react";

const ThumbDownSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25">
        <path
            fill="#E11D48"
            d="M6.5 2h11v13l-7 7-1.25-1.25a1.3 1.3 0 0 1-.287-.476 1.6 1.6 0 0 1-.113-.575v-.35L9.95 15H3.5q-.8 0-1.4-.6T1.5 13v-2q0-.174.05-.375.05-.2.1-.375l3-7.05q.225-.5.75-.85T6.5 2m9 2h-9l-3 7v2h9l-1.35 5.5 4.35-4.35zm.037 10.15V4zM17.5 15v-2h3V4h-3V2h5v13z"
        ></path>
    </svg>
);

export default ThumbDownSVG;
